// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gFTH8","questions":"styles_questions__1PSGq","footer":"styles_footer__YMgpr"};